import { StandardAppConfig } from './StandardAppConfig';
import React from 'react';

/**
 * Format: `errorMessages.${pageName}.${archetype}.${fieldName}.${errorName}`.<br>
 * fieldName must be unique within a pageName+archetype, or node IDs and ErrorSummary links must be made more explicit.
 * @see getErrorMessage
 */
export const standardMessages = (appConfig: StandardAppConfig) => ({
    errorMessages: {
        eligibilityPage: {
            personalDisaster: {
                ownerOrRenter: {
                    required: 'Select an option between owning and renting.'
                },
                ownerOccupierOrInvestor: {
                    required: 'Select an option between owner occupier and investor.'
                },
                peopleLivingAtAddress: {
                    required: 'Select an option about who lives at the address.'
                },
                insurance: {
                    required: 'Select an option about insurance.',
                    NotInList: 'This grant provides support to people who are not fully insured ' +
                        'for property damage or household contents.'
                },
                impactedAddressSource: {
                    required: 'Select the impacted address.'
                },
                impactedAddress: {
                    required: 'Enter the impacted address.',
                    validAddress: 'Specify a valid address.'
                },
                eligibilityCheck: {
                    // eslint-disable-next-line max-len
                    UNIQUE_APPLICATION_PER_ADDRESS: <>We've received an application for this address.<br /><br />We can assess one application per address. Check the <a
                        href={ appConfig.links.eligibilityDetailsLink }
                        target='_blank'
                        rel='noreferrer'
                    >eligibility guidelines</a>.<br /><br />If you need any help, call <a href='tel:13 77 88'>13 77 88</a>.</>,
                    // eslint-disable-next-line max-len
                    UNIQUE_APPLICATION_PER_CUSTOMER: <>An application with your details already exists.<br /><br />If you need any help, call <a href='tel:13 77 88'>13 77 88</a>.</>,
                    // eslint-disable-next-line max-len
                    ADDRESS_WITHIN_LGA: <>Your address is not listed within the disaster affected locations.<br /><br /> The { appConfig.appTitle } is available for homes within declared local government areas. Check the <a
                        href={ appConfig.links.eligibilityDetailsLink }
                        target='_blank'
                        rel='noreferrer'
                    >eligibility guidelines</a>.</>,
                    NOT_A_PUBLIC_COMPANY: <>Public companies are not eligible for the {appConfig.appTitle} grant.<br /><br />The {appConfig.appTitle} grant provides support to small business owners and not-for-profit organisations. Check the <a
                        href={ appConfig.links.eligibilityDetailsLink }
                        target='_blank'
                        rel='noreferrer'
                    >eligibility guidelines</a>.</>,
                    ACTIVE_ABN_ON_DISASTER_DATE: <>Eligible businesses need to have an Australian Business Number (ABN) registered before {appConfig.disasterDate} to apply. Check the <a
                        href={ appConfig.links.eligibilityDetailsLink }
                        target='_blank'
                        rel='noreferrer'
                    >eligibility guidelines</a>.</>,
                    ACTIVE_ABN_ON_APPLICATION_DATE: <>Your Australian Business Number (ABN) is inactive. <br /><br />Eligible businesses need to have an active ABN to apply. Check the <a
                        href={ appConfig.links.eligibilityDetailsLink }
                        target='_blank'
                        rel='noreferrer'
                    >eligibility guidelines</a>.</>
                },
            },
            businessDisaster: {
                business: {
                    abn: {
                        EligibilityCriteria: 'Provide your business\' 11-digit ABN.'
                    },
                    businessName: {
                        required: 'Enter business name.'
                    },
                },
                directDamages: {
                    NotInList: 'Your business must have suffered direct damages to be eligible.',
                    required: 'Select an option about direct damage to your business.',
                },
                employees: {
                    ValueType: 'Ensure the number of employees is a number.',
                    required: 'Enter the number of employees.',
                    Rule: 'Your business\' number of employees is higher than the maximum supported.'
                },
                hasAbn: {
                    required: 'Select an option about registered ABN.'
                },
                insurance: {
                    EligibilityCriteria: 'Your insurance must not fully cover all the costs of repairs to be eligible.',
                    required: 'Select an option about insurance.'
                },
                intendToReEstablish: {
                    NotInList: 'You must intend to re-establish the business to be eligible.',
                    required: 'Select an option about whether you intend to re-establish.'
                },
                operatedDuringDisaster: {
                    NotInList: 'Your business must have operated during the disaster to be eligible.',
                    required: 'Specify whether you operated the business during the disaster.'
                },
                hasFullTimeEmployees: {
                    required: 'Select an option about full-time staff'
                },
            }
        }
    },
    helpMessages: {},
    labels: {}
});
